import { Badge } from '@@/ui/primitives';

export interface PromptValue {
  content: string;
  kind: string;
}

interface PromptViewerProps {
  value: PromptValue;
  full?: boolean;
}

export function PromptViewer({ value, full = false }: PromptViewerProps) {
  if (full) {
    return (
      <div className='flex flex-col gap-2'>
        {/* <Badge
          variant='outline'
          className='text-xs text-neutral-950 border-neutral-300 w-fit'
        >
          {value.kind === 'TEXT' ? 'Text' : 'SSML'}
        </Badge> */}
        <div className='bg-neutral-50 p-2 rounded-md border border-neutral-200'>
          <pre className='text-sm! font-mono whitespace-pre-wrap wrap-break-word'>{value.content || '(empty)'}</pre>
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-row items-center gap-2'>
      <Badge variant='outline' className='text-xs text-neutral-950 border-neutral-300'>
        {value.kind === 'TEXT' ? 'Text' : 'SSML'}
      </Badge>
    </div>
  );
}
